import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import routes from './routes/index';
import "./i18n";
import {createBrowserRouter, RouterProvider} from "react-router-dom";

const router = createBrowserRouter(routes);

function App() {

    return (
        <div className="container-fluid">
            <RouterProvider router={router}/>
        </div>);
}


export default App;
